import { handleAxiosError } from 'core/notifications';
import axios from '@/util/axios';

import getAxiosConfig from './getAxiosConfig';

export default async ({ id, isInLiveMode, selectedLocales = [], currentLocale }) => {
  const configName = isInLiveMode ? 'publish-live-video' : 'publish-video';
  const locales = [currentLocale, ...selectedLocales];
  const payload = !isInLiveMode || selectedLocales.length > 0 ? { data: { locales } } : null;

  try {
    await axios(getAxiosConfig(configName, { id, payload }));
  } catch (error) {
    handleAxiosError(error);
  }
};
